import { Button, Modal, Spinner, Text } from '@shared/widgets';

interface Props {
  show: boolean;
  onClose: () => void;
  onRequest: () => void;
  lastDigits: string;
  cardHolder: string;
  loading: boolean;
}

export const ActivateModal = (props: Props) => {
  const request = async () => {
    await props.onRequest();
    props.onClose();
  };

  return (
    <Modal isOpen={props.show} onClose={props.onClose} title='Activate card'>
      {props.loading ? (
        <Spinner />
      ) : (
        <>
          <Text weight='medium'>
            Are you sure you want to activate <b>{props.cardHolder}’s</b> card ending <b>{props.lastDigits}</b>?
          </Text>
          <div className='mt-6'>
            <div className='flex justify-between -my-3'>
              <div className='flex-none px-3 w-3/6'>
                <Button fullWidth color='outlined' onClick={props.onClose}>
                  Decline
                </Button>
              </div>
              <div className='flex-none px-3 w-3/6'>
                <Button fullWidth color='primary' onClick={request}>
                  Request
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};
